import { useController } from 'react-hook-form'

import { TextField } from '../../legacy-form-fields'
import { AccentraConnectionFormValues } from './accentra.schema'

const useTextFieldProps = (name: keyof AccentraConnectionFormValues) => {
  const { field, fieldState } = useController<AccentraConnectionFormValues>({ name })
  return {
    errorLabel: fieldState.error?.message,
    isError: Boolean(fieldState.error),
    name: field.name,
    onBlur: field.onBlur,
    onChange: field.onChange,
    value: field.value ?? '',
  }
}

export const AccentraFields = () => {
  const login = useTextFieldProps('login')
  const password = useTextFieldProps('password')

  return (
    <div className="integration-configuration">
      <TextField {...login} label="Login" placeholder="Enter Accentra Login" />
      <TextField
        {...password}
        label="Password"
        placeholder="Enter Accentra Password"
        type="password"
      />
    </div>
  )
}
